<!-- 仓库小游戏：分拣货物（传送带流水线）+ 清扫货仓（点击消除） -->
<template>
    <div id="warehouseGameDiv" class="wrap">
        <el-dialog
            :visible.sync="warehouseGameVisible"
            :before-close="warehouse_game_dialog_close"
            :close-on-click-modal="phase !== 'playing'"
            title="仓库"
            width="520px">
            <!-- 得分飘字层（相对 .el-dialog 定位） -->
            <div class="wg-floaters">
                <span v-for="f in floaters" :key="f.id" class="wg-floater"
                      :class="f.cls" :style="{left: f.x + 'px', top: f.y + 'px'}">{{f.text}}</span>
            </div>

            <!-- 顶部状态栏 -->
            <div class="wg-top" v-if="phase !== 'idle'">
                <div class="wg-timer-wrap" :class="{danger: remainSec <= 10}">
                    <div class="wg-timebar" :style="{width: timePct + '%'}"></div>
                    <span class="wg-timer-num">⏱ {{remainSec}}s</span>
                </div>
                <span class="wg-score">得分 {{score}}</span>
                <span class="wg-count" v-if="gameType === 'sort'">已分拣 {{pickedCount}}/{{items.length}}</span>
                <span class="wg-count" v-else>已清扫 {{cleanedList.length}}/{{debris.length}}</span>
                <span class="wg-count wg-miss" v-if="gameType === 'clean' && missedCount > 0">溜走 {{missedCount}}</span>
                <span v-if="combo >= 2" class="wg-combo">🔥×{{combo}}</span>
            </div>

            <!-- ============ 分拣货物（传送带） ============ -->
            <div v-if="gameType === 'sort'" class="sort-scene">
                <div v-if="phase === 'idle'" class="wg-idle">
                    <div class="wg-idle-icon">📦</div>
                    <p class="wg-quota" v-if="remaining !== null">今日剩余 <b>{{remaining}}</b> 局<span v-if="firstDouble && remaining >= dailyLimit" class="wg-quota-double">　首局奖励×2</span></p>
                    <p>货物从机器口逐个出来，沿传送带向左移动，拖进正确的分类箱！<br>正确 +10，错误 -5，连击 ×3 额外 +10</p>
                    <p class="wg-idle-tip">限时 45 秒 · 也可以<b>点一下货物再点箱子</b>放下（手机推荐）<br>机器窗口预告下一件货物；上带后约 4.5 秒溜到挡板，从容分拣！</p>
                    <el-button type="primary" round @click="startGame">开始分拣</el-button>
                </div>
                <template v-else>
                    <!-- 手持提示（点选模式） -->
                    <div v-if="carrying" class="wg-carrying">
                        <span class="wg-carrying-emoji">{{heldItem && heldItem.emoji}}</span>
                        <span>手持货物——点击分类箱放下</span>
                        <el-button size="mini" round @click="putBackCarried">放回传送带</el-button>
                    </div>

                    <!-- 传送带场景 -->
                    <div class="belt-scene">
                        <div class="belt-guard">
                            <span class="belt-guard-icon">🚧</span>
                        </div>
                        <div class="belt" ref="belt">
                            <div v-for="item in visibleItems" :key="item.index"
                                 class="belt-item"
                                 :class="{'belt-item-held': item.state === 'held'}"
                                 :style="{left: beltLeft(item)}"
                                 @pointerdown="pickUp(item, $event)">
                                <span class="belt-item-emoji">{{item.emoji}}</span>
                            </div>
                            <div class="belt-arrow">⬅</div>
                        </div>
                        <div class="belt-machine" :class="{'machine-pop': machinePop}">
                            <div class="machine-preview" v-if="nextItem" title="下一件预告">
                                <span class="machine-preview-emoji">{{nextItem.emoji}}</span>
                                <span class="machine-preview-label">下一件</span>
                            </div>
                            <span v-else class="belt-machine-icon">🏭</span>
                        </div>
                    </div>

                    <!-- 分类箱 -->
                    <div class="sort-cats">
                        <div v-for="cat in categories" :key="cat.index" class="sort-cat"
                             :ref="'cat_' + cat.index"
                             :class="{
                               'sort-cat-good': catFlash === cat.index && catFlashOk,
                               'sort-cat-bad': catFlash === cat.index && !catFlashOk,
                               'sort-cat-pop': catFlash === cat.index
                             }"
                             @click="dropCarried(cat.index)">
                            <span class="cat-badge" v-if="catCounts[cat.index]">{{catCounts[cat.index]}}</span>
                            <span class="cat-emoji">{{cat.emoji}}</span>
                            <span class="cat-name">{{cat.catName}}</span>
                        </div>
                    </div>

                    <!-- 操作条 -->
                    <div class="sort-actions" v-if="phase === 'playing'">
                        <el-button type="success" round :disabled="settling" @click="finishSort">✅ 完成分拣</el-button>
                        <span class="sort-actions-tip">货物滑到挡板就没了，手速要快！</span>
                    </div>

                    <div v-if="phase === 'result' && result" class="wg-result">
                        <p class="wg-result-title" :class="result.success ? 'ok' : 'bad'">{{result.message}}</p>
                        <div class="wg-reward-row" v-if="result.data">
                            <span class="wg-reward-item">🪙 金币 +{{result.data.addMoney}}</span>
                            <span class="wg-reward-item">⭐ 经验 +{{result.data.addExp}}</span>
                            <span class="wg-reward-item" v-if="result.data.titleMastery">🎖️ {{result.data.titleMastery.text}}</span>
                        </div>
                        <div class="wg-result-actions">
                            <el-button type="primary" round v-if="result.success" @click="startGame">再来一局</el-button>
                            <el-button round @click="warehouse_game_dialog_close">关闭</el-button>
                        </div>
                    </div>
                </template>
            </div>

            <!-- ============ 清扫货仓（地鼠式） ============ -->
            <div v-else class="clean-scene">
                <div v-if="phase === 'idle'" class="wg-idle">
                    <div class="wg-idle-icon">🧹</div>
                    <p class="wg-quota" v-if="remaining !== null">今日剩余 <b>{{remaining}}</b> 局<span v-if="firstDouble && remaining >= dailyLimit" class="wg-quota-double">　首局奖励×2</span></p>
                    <p>杂物会从仓库地洞里不断冒出来，手疾眼快点它清扫！<br>每件 +2，限时抓住全部 20 件额外 +30</p>
                    <p class="wg-idle-tip">限时 35 秒 · 没抓住的杂物还会再冒出来，别放过它们！<br>冒头速度会越来越快，稳住手！</p>
                    <el-button type="primary" round @click="startGame">开始清扫</el-button>
                </div>
                <template v-else>
                    <div class="whack-board">
                        <div v-for="(h, i) in holes" :key="i" class="whack-hole"
                             :class="{'whack-hole-hot': h.state === 'up'}"
                             @click="cleanWhack(h, $event)">
                            <span v-if="h.state === 'up' && h.debris" class="whack-debris">{{h.debris.emoji}}</span>
                            <span v-if="h.state === 'caught'" class="whack-dust">✨</span>
                        </div>
                    </div>
                    <div class="sort-actions" v-if="phase === 'playing'">
                        <el-button type="success" round :disabled="settling" @click="finishSort">✅ 完成清扫</el-button>
                        <span class="sort-actions-tip">时间到或全部抓住后自动结算</span>
                    </div>
                    <div v-if="phase === 'result' && result" class="wg-result">
                        <p class="wg-result-title" :class="result.success ? 'ok' : 'bad'">{{result.message}}</p>
                        <div class="wg-reward-row" v-if="result.data">
                            <span class="wg-reward-item">🪙 金币 +{{result.data.addMoney}}</span>
                            <span class="wg-reward-item">⭐ 经验 +{{result.data.addExp}}</span>
                            <span class="wg-reward-item" v-if="result.data.titleMastery">🎖️ {{result.data.titleMastery.text}}</span>
                        </div>
                        <div class="wg-result-actions">
                            <el-button type="primary" round v-if="result.success" @click="startGame">再来一局</el-button>
                            <el-button round @click="warehouse_game_dialog_close">关闭</el-button>
                        </div>
                    </div>
                </template>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { postRequest } from '../../utils/api'
import Message from 'element-ui/lib/message'
// 传送带节奏：出件间隔 / 单件全程时长（毫秒）
const SPAWN_INTERVAL_MS = 1300
const BELT_TRAVEL_MS = 4500

export default {
  name: 'warehouseGame',
  props: {
    warehouseGameVisible: Boolean,
    warehouseGameType: { type: String, default: 'sort' }
  },
  data() {
    return {
      gameType: 'sort',
      phase: 'idle',            // idle | playing | result
      items: [],                // 分拣货物（含 state/pos/enterTime）
      categories: [],           // 分类箱
      debris: [],               // 清扫杂物
      cleanedList: [],          // 已清扫索引列表
      holes: [],                // 清扫地鼠洞（9 个槽位：state=empty|up|caught + debris + upSince）
      cleanQueue: [],           // 待冒头杂物队列（洗牌序，溜掉的排队再冒）
      whackTimer: null,         // 清扫地鼠主循环
      lastSpawnAt: 0,           // 上次冒头时间（控制冒头间隔）
      lastCatchAt: 0,           // 上次抓中时间（连击展示）
      missedCount: 0,           // 溜走次数
      score: 0,
      combo: 0,
      remainSec: 45,
      totalSec: 45,             // 时间进度条总量
      timer: null,              // 限时倒计时
      spawnTimer: null,         // 传送带出件定时器
      beltTimer: null,          // 传送带移动定时器
      result: null,
      // 拖拽状态
      heldItem: null,           // 当前拿起的物品（含点选携带）
      carrying: false,          // 点选模式：手持中，等玩家点箱子
      dragStart: null,          // pointerdown 起点（区分点击与拖动）
      dragClone: null,          // 跟随指针的克隆元素
      dragHandlers: null,       // 拖拽期间的 document 监听器
      // 表现层状态
      machinePop: false,        // 机器出件抖动
      catFlash: null,           // 分类箱命中闪烁（索引）
      catFlashOk: false,
      catCounts: {},            // 各箱投放数角标
      floaters: [],             // 得分飘字
      floaterSeq: 0,
      picks: [],                // 分拣交互记录 {itemIndex, targetIndex}
      settling: false,
      autoSettleFired: false,
      // 今日次数（面板展示；status 接口初值 + start/settle 响应刷新）
      remaining: null,
      dailyLimit: 3,
      firstDouble: false
    };
  },
  computed: {
    pickedCount() {
      return this.items.filter(i => i.state === 'picked').length;
    },
    // 传送带上可见：移动中/被拿起（queued 未出场由机器窗预告、picked/expired 已离场都不显示）
    visibleItems() {
      return this.items.filter(i => i.state === 'moving' || i.state === 'held');
    },
    // 机器窗预告：下一个待出场的货物
    nextItem() {
      return this.items.find(i => i.state === 'queued') || null;
    },
    timePct() {
      return this.totalSec ? Math.max(0, Math.round(this.remainSec / this.totalSec * 100)) : 0;
    }
  },
  created() {
    // 组件由父级 v-if 挂载，挂载时 props 已是最终值（watch 不会触发），在此初始化游戏类型
    this.gameType = this.warehouseGameType;
    this.loadStatus();
  },
  beforeDestroy() {
    this.stopTimers();
    this.removeDragClone();
  },
  watch: {
    // 兜底：组件实例被复用（未销毁再次展示）时同步游戏类型
    warehouseGameVisible(val) {
      if (val) {
        this.gameType = this.warehouseGameType;
        this.resetAll();
      }
    }
  },
  methods: {
    // 今日剩余次数/首局翻倍标记（面板展示；start/settle 响应会带最新 remaining）
    loadStatus() {
      postRequest('/item/warehouseGame/status', {}).then(resp => {
        if (resp.status == 200 && resp.data.status == 200 && resp.data.data) {
          this.remaining = resp.data.data.remaining;
          this.dailyLimit = resp.data.data.dailyLimit || 3;
          this.firstDouble = !!resp.data.data.firstDouble;
        }
      }, () => {});
    },
    resetAll() {
      this.stopTimers();
      this.removeDragClone();
      this.phase = 'idle';
      this.items = [];
      this.categories = [];
      this.debris = [];
      this.cleanedList = [];
      this.holes = [];
      this.cleanQueue = [];
      this.missedCount = 0;
      this.lastCatchAt = 0;
      this.score = 0;
      this.combo = 0;
      this.remainSec = 45;
      this.totalSec = 45;
      this.result = null;
      this.heldItem = null;
      this.carrying = false;
      this.dragStart = null;
      this.machinePop = false;
      this.catFlash = null;
      this.catCounts = {};
      this.floaters = [];
      this.picks = [];
      this.settling = false;
      this.autoSettleFired = false;
    },
    stopTimers() {
      if (this.timer) { clearInterval(this.timer); this.timer = null; }
      if (this.spawnTimer) { clearInterval(this.spawnTimer); this.spawnTimer = null; }
      if (this.beltTimer) { clearInterval(this.beltTimer); this.beltTimer = null; }
      if (this.whackTimer) { clearInterval(this.whackTimer); this.whackTimer = null; }
      this.removeDragHandlers();
    },
    removeDragHandlers() {
      if (this.dragHandlers) {
        document.removeEventListener('pointermove', this.dragHandlers.move);
        document.removeEventListener('pointerup', this.dragHandlers.up);
        this.dragHandlers = null;
      }
    },
    // 开始游戏：请求后端生成关卡
    startGame() {
      const _this = this;
      this.settling = false;
      postRequest('/item/warehouseGame/start', {
        gameType: this.gameType
      }).then(resp => {
        if (resp.status == 200) {
          const rd = resp.data;
          if (200 == rd.status) {
            if (rd.data.remaining !== undefined) {
              _this.remaining = rd.data.remaining;
            }
            if (_this.gameType === 'sort') {
              const raw = rd.data.items || [];
              // 初始化流水线状态：queued(未出场,机器窗预告)=出场即 moving(传送带移动中)
              _this.items = raw.map((it, n) => Object.assign({}, it, {
                state: 'queued',       // 未入场
                pos: 0,                // 传送带位置 0右侧~1左端
                enterTime: 0,          // 入场时间戳
                spawnOrder: n
              }));
              _this.categories = rd.data.categories || [];
              _this.picks = [];
              _this.score = 0;
              _this.combo = 0;
              _this.remainSec = 45;
              _this.totalSec = 45;
              _this.heldItem = null;
              _this.carrying = false;
              _this.catCounts = {};
              _this.floaters = [];
              _this.autoSettleFired = false;
              _this.phase = 'playing';
              _this.startTimer();
              _this.startBelt();
            } else {
              _this.debris = rd.data.debris || [];
              _this.cleanedList = [];
              _this.holes = Array.from({ length: 9 }, () => ({ state: 'empty', debris: null, upSince: 0 }));
              // 洗牌出怪队列
              const queue = _this.debris.map(d => d.index);
              for (let i = queue.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                const t = queue[i]; queue[i] = queue[j]; queue[j] = t;
              }
              _this.cleanQueue = queue;
              _this.missedCount = 0;
              _this.score = 0;
              _this.combo = 0;
              _this.remainSec = 35;
              _this.totalSec = 35;
              _this.picks = [];
              _this.floaters = [];
              _this.autoSettleFired = false;
              _this.phase = 'playing';
              _this.startTimer();
              _this.startWhack();
            }
          } else {
            Message.error(rd.message || '游戏开始失败');
          }
        } else {
          Message.error('用户非法⊙﹏⊙∥!');
        }
      }, () => {
        Message.error('用户非法⊙﹏⊙∥!');
      });
    },
    startTimer() {
      this.stopTimerOnly();
      this.timer = setInterval(() => {
        this.remainSec--;
        if (this.remainSec <= 0) {
          this.stopTimerOnly();
          // 提前结算（全部完成/点完成）已进入 result 阶段时不能再结算一次（会双倍发奖励）
          if (this.phase === 'playing') {
            this.phase = 'result';
            this.settle();
          }
        }
      }, 1000);
    },
    stopTimerOnly() {
      if (this.timer) { clearInterval(this.timer); this.timer = null; }
    },
    // ============ 传送带流水线 ============
    startBelt() {
      this.stopBeltTimers();
      // 出件：按出件间隔放一件上带（直接出发；下一件在机器窗预告）
      this.spawnTimer = setInterval(() => {
        if (this.phase !== 'playing') return;
        const item = this.items.find(i => i.state === 'queued');
        // 出完只停出件定时器；移动/结算交给 beltTimer 的 pending 判定，
        // 否则最后一件会永远冻在机器口、带上物品全部停住
        if (!item) { clearInterval(this.spawnTimer); this.spawnTimer = null; return; }
        item.state = 'moving';
        item.enterTime = Date.now();
        item.pos = 0;
        const _this = this;
        this.machinePop = true;
        setTimeout(() => { _this.machinePop = false; }, 300);
      }, SPAWN_INTERVAL_MS);
      // 移动：moving 从 0 到 1（全程 BELT_TRAVEL_MS）
      this.beltTimer = setInterval(() => {
        if (this.phase !== 'playing') return;
        const now = Date.now();
        for (const item of this.items) {
          if (item.state === 'moving') {
            item.pos = Math.min(1, (now - item.enterTime) / BELT_TRAVEL_MS);
            if (item.pos >= 1) {
              item.state = 'expired';               // 溜走到挡板，不可再选
            }
          }
        }
        // 还有未出场/在带/被拿起的物品时不能停表（held 期间停表会导致松手后传送带冻结）
        const pending = this.items.some(i =>
          i.state === 'queued' || i.state === 'moving' || i.state === 'held');
        if (!pending) { this.stopBeltTimers(); this.checkAutoSettle(); }
      }, 100);
    },
    stopBeltTimers() {
      if (this.spawnTimer) { clearInterval(this.spawnTimer); this.spawnTimer = null; }
      if (this.beltTimer) { clearInterval(this.beltTimer); this.beltTimer = null; }
    },
    beltLeft(item) {
      // 传送带内：pos 0=右侧机器口(91%)，1=左端挡板(2%)
      const pct = 91 - item.pos * 89;
      return pct + '%';
    },
    checkAutoSettle() {
      if (this.autoSettleFired || this.phase !== 'playing') return;
      const allDone = this.items.every(i => i.state === 'picked' || i.state === 'expired');
      if (allDone) {
        this.autoSettleFired = true;
        // 最后一件溜走后稍等结算，给玩家一屏结果提示
        setTimeout(() => {
          if (this.phase === 'playing') {
            this.phase = 'result';
            this.settle();
          }
        }, 600);
      }
    },
    // ============ 拖拽 / 点选（统一 pointer 方案，桌面/触屏通用） ============
    pickUp(item, e) {
      if (this.phase !== 'playing') return;
      if (this.heldItem) return;                    // 点选模式下手持中，不能再抓一件
      if (item.state !== 'moving') return;
      e.preventDefault();
      e.stopPropagation();
      this.heldItem = item;
      this.dragStart = { x: e.clientX, y: e.clientY };
      item.state = 'held';
      this.spawnDragClone(item.emoji, e.clientX, e.clientY);
      const _this = this;

      const move = (ev) => {
        _this.moveDragClone(ev.clientX, ev.clientY);
      };
      const up = (ev) => {
        document.removeEventListener('pointermove', move);
        document.removeEventListener('pointerup', up);
        _this.dragHandlers = null;
        const dist = _this.dragStart ? Math.hypot(ev.clientX - _this.dragStart.x, ev.clientY - _this.dragStart.y) : 99;
        _this.releasePick(ev.clientX, ev.clientY, dist < 6);
      };
      this.dragHandlers = { move, up };
      document.addEventListener('pointermove', move);
      document.addEventListener('pointerup', up);
    },
    spawnDragClone(emoji, x, y) {
      this.removeDragClone();
      const clone = document.createElement('div');
      clone.className = 'wg-drag-clone';
      clone.textContent = emoji;
      clone.style.left = x + 'px';
      clone.style.top = y + 'px';
      document.body.appendChild(clone);
      this.dragClone = clone;
    },
    moveDragClone(x, y) {
      if (this.dragClone) {
        this.dragClone.style.left = x + 'px';
        this.dragClone.style.top = y + 'px';
      }
    },
    removeDragClone() {
      if (this.dragClone && this.dragClone.parentNode) {
        this.dragClone.parentNode.removeChild(this.dragClone);
      }
      this.dragClone = null;
    },
    releasePick(x, y, isTap) {
      const item = this.heldItem;
      if (!item || this.phase !== 'playing') {
        if (item && item.state === 'held') this.revertHeld(item);
        this.heldItem = null;
        this.carrying = false;
        this.removeDragClone();
        return;
      }
      const catIdx = isTap ? -1 : this.hitCat(x, y);
      if (catIdx >= 0) {
        this.recordPick(item.index, catIdx);
        this.heldItem = null;
        this.carrying = false;
        this.removeDragClone();
      } else if (isTap) {
        // 点选模式：货物收进"手持"，等玩家点分类箱放下
        this.carrying = true;
        this.removeDragClone();
      } else {
        // 拖动后没放到箱子上：放回传送带，按拿起来时的进度继续开动
        this.revertHeld(item);
        this.heldItem = null;
        this.carrying = false;
        this.removeDragClone();
      }
    },
    revertHeld(item) {
      // 放回传送带：按当前 pos 恢复移动（含刚出场被拿起的 pos=0）
      item.state = 'moving';
      item.enterTime = Date.now() - item.pos * BELT_TRAVEL_MS;
    },
    putBackCarried() {
      if (this.heldItem && this.heldItem.state === 'held') this.revertHeld(this.heldItem);
      this.heldItem = null;
      this.carrying = false;
    },
    // 点选模式：点击分类箱放下手持货物
    dropCarried(catIndex) {
      if (!this.heldItem || this.heldItem.state !== 'held' || this.phase !== 'playing') return;
      this.recordPick(this.heldItem.index, catIndex);
      this.heldItem = null;
      this.carrying = false;
    },
    hitCat(x, y) {
      // 纯矩形命中（外扩容差）。不做距离兜底：传送带就在箱子上方，
      // 机器口/带上的货物离箱子中心很近，距离兜底会把"没放到箱子上"误判成投放
      const slack = window.innerWidth <= 768 ? 16 : 26;
      for (const cat of this.categories) {
        const elArr = this.$refs['cat_' + cat.index];
        const el = Array.isArray(elArr) ? elArr[0] : elArr;
        if (!el) continue;
        const r = el.getBoundingClientRect();
        if (x >= r.left - slack && x <= r.right + slack && y >= r.top - slack && y <= r.bottom + slack) {
          return cat.index;
        }
      }
      return -1;
    },
    recordPick(itemIndex, targetIndex) {
      const item = this.items.find(x => x.index === itemIndex);
      if (!item) return;
      if (item.state === 'picked' || item.state === 'expired') return;
      item.state = 'picked';
      const cat = this.categories.find(c => c.index === targetIndex);
      const correct = !!cat && cat.catKey === item.catKey;
      this.picks.push({ itemIndex: itemIndex, targetIndex: targetIndex });
      this.$set(this.catCounts, targetIndex, (this.catCounts[targetIndex] || 0) + 1);
      this.catFlash = targetIndex;
      this.catFlashOk = correct;
      const elArr = this.$refs['cat_' + targetIndex];
      const el = Array.isArray(elArr) ? elArr[0] : elArr;
      if (el && correct) {
        this.combo++;
        let gain = 10;
        if (this.combo >= 3) gain += 10;
        this.score += gain;
        const r = el.getBoundingClientRect();
        this.addFloater('+' + gain + (this.combo >= 3 ? ' 🔥×' + this.combo : ''), 'good',
          r.left + r.width / 2, r.top);
      } else if (el) {
        this.score = Math.max(0, this.score - 5);
        this.combo = 0;
        const r = el.getBoundingClientRect();
        this.addFloater('-5', 'bad', r.left + r.width / 2, r.top);
      }
      const _this = this;
      setTimeout(() => { if (_this.catFlash === targetIndex) _this.catFlash = null; }, 350);
      // 分拣完成也可能提前（拖完全部物品）
      const left = this.items.filter(i => i.state !== 'picked' && i.state !== 'expired');
      if (left.length === 0) { this.checkAutoSettle(); }
    },
    // 得分飘字：坐标转为相对弹窗的偏移
    addFloater(text, cls, clientX, clientY) {
      const dlg = this.$el.querySelector('.el-dialog');
      if (!dlg) return;
      const dr = dlg.getBoundingClientRect();
      const id = ++this.floaterSeq;
      this.floaters.push({ id, text, cls, x: clientX - dr.left, y: clientY - dr.top });
      const _this = this;
      setTimeout(() => { _this.floaters = _this.floaters.filter(f => f.id !== id); }, 900);
    },
    // ============ 清扫货仓（地鼠式主循环） ============
    startWhack() {
      if (this.whackTimer) { clearInterval(this.whackTimer); this.whackTimer = null; }
      this.lastSpawnAt = 0;
      this.whackTimer = setInterval(() => {
        if (this.phase !== 'playing') return;
        const now = Date.now();
        const caught = this.cleanedList.length;
        const upMs = Math.max(1000, 1700 - caught * 35);     // 冒头时间随进度缩短（1.7s → 1.0s）
        const target = caught >= 8 ? 2 : 1;                    // 后期同时冒两件
        // 到点没被抓 → 缩回地洞，排队再冒
        for (const h of this.holes) {
          if (h.state === 'up' && now - h.upSince > upMs) {
            this.cleanQueue.push(h.debris.index);
            h.state = 'empty';
            h.debris = null;
            this.missedCount++;
          }
        }
        // 冒头：空槽够、队列有货、距上次冒头 ≥450ms
        const activeCount = this.holes.filter(h => h.state === 'up').length;
        if (activeCount < target && this.cleanQueue.length > 0 && now - this.lastSpawnAt >= 450) {
          const empties = this.holes.filter(h => h.state === 'empty');
          if (empties.length > 0) {
            const slot = empties[Math.floor(Math.random() * empties.length)];
            const idx = this.cleanQueue.shift();
            const d = this.debris.find(x => x.index === idx);
            if (d) {
              slot.debris = d;
              slot.state = 'up';
              slot.upSince = now;
              this.lastSpawnAt = now;
            } else {
              this.cleanQueue.push(idx);
            }
          }
        }
      }, 100);
    },
    cleanWhack(h, e) {
      if (this.phase !== 'playing' || h.state !== 'up' || !h.debris) return;
      const now = Date.now();
      this.combo = (now - this.lastCatchAt <= 1500) ? this.combo + 1 : 1;
      this.lastCatchAt = now;
      this.cleanedList.push(h.debris.index);
      this.score += 2;
      if (e && e.currentTarget && e.currentTarget.getBoundingClientRect) {
        const r = e.currentTarget.getBoundingClientRect();
        this.addFloater('+2' + (this.combo >= 3 ? ' 🔥×' + this.combo : ''), 'good',
          r.left + r.width / 2, r.top);
      }
      h.state = 'caught';
      const _this = this;
      setTimeout(() => {
        h.state = 'empty';
        h.debris = null;
        if (_this.cleanedList.length === _this.debris.length && !_this.autoSettleFired) {
          // 全部抓住自动结算
          _this.autoSettleFired = true;
          setTimeout(() => {
            if (_this.phase === 'playing') {
              _this.phase = 'result';
              _this.settle();
            }
          }, 700);
        }
      }, 300);
    },
    // ============ 提前完成/结算 ============
    finishSort() {
      if (this.phase !== 'playing' || this.settling) return;
      this.phase = 'result';
      this.settle();
    },
    settle() {
      if (this.settling) return;                   // 防重复结算（倒计时归零/自动结算/手动完成并发）
      this.settling = true;
      this.stopTimers();
      const _this = this;
      const payload = this.gameType === 'sort'
        ? JSON.stringify(this.picks)
        : JSON.stringify(this.cleanedList.map(idx => ({ debrisIndex: idx })));
      postRequest('/item/warehouseGame/settle', {
        gameType: this.gameType,
        payload: payload
      }).then(resp => {
        if (resp.status == 200) {
          const rd = resp.data;
          if (200 == rd.status) {
            _this.result = { success: true, message: rd.message, data: rd.data };
            if (rd.data && rd.data.remaining !== undefined) {
              _this.remaining = rd.data.remaining;
            }
            _this.$store.dispatch('user/fetchUserDetail');
          } else {
            _this.result = {
              success: false,
              message: rd.message || '结算失败',
              data: null
            };
          }
        } else {
          _this.result = { success: false, message: '用户非法⊙﹏⊙∥!', data: null };
        }
      }, () => {
        _this.result = { success: false, message: '用户非法⊙﹏⊙∥!', data: null };
      });
    },
    warehouse_game_dialog_close() {
      this.stopTimers();
      this.removeDragClone();
      this.resetAll();
      this.$emit("warehouse_game_dialog_close");
    }
  }
}
</script>

<style scoped>
/* 游戏弹窗整体禁止选中文字：拖拽货物经过说明/按钮时避免触发浏览器原生文本选择 */
#warehouseGameDiv /deep/ .el-dialog {
  user-select: none;
  -webkit-user-select: none;
}
/* ============ 顶部状态栏 ============ */
.wg-top {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 14px;
  font-size: 15px;
  font-weight: bold;
}
.wg-timer-wrap {
  position: relative;
  width: 110px;
  height: 18px;
  border-radius: 9px;
  background: #eceff1;
  overflow: hidden;
  flex-shrink: 0;
}
.wg-timebar {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  border-radius: 9px;
  background: linear-gradient(90deg, #66bb6a, #43a047);
  transition: width .3s linear;
}
.wg-timer-wrap.danger .wg-timebar {
  background: linear-gradient(90deg, #ef5350, #e53935);
}
.wg-timer-num {
  position: relative;
  z-index: 1;
  display: block;
  text-align: center;
  line-height: 18px;
  font-size: 12px;
  color: #37474f;
}
.wg-score { color: #b8860b; }
.wg-count { color: #555; font-size: 13px; font-weight: normal; }
.wg-combo {
  color: #fff;
  background: linear-gradient(90deg, #ff9800, #f57c00);
  border-radius: 10px;
  padding: 1px 10px;
  font-size: 13px;
  animation: combo-pulse .6s ease-out;
}
@keyframes combo-pulse {
  0% { transform: scale(1.4); }
  100% { transform: scale(1); }
}
/* ============ 开场说明 ============ */
.wg-idle {
  text-align: center;
  padding: 18px 0 26px;
  background: linear-gradient(180deg, #fffdf5, #faf5ea);
  border-radius: 10px;
}
.wg-idle-icon { font-size: 46px; margin-bottom: 12px; animation: idle-bob 2s ease-in-out infinite; }
@keyframes idle-bob {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-6px); }
}
.wg-idle p { margin: 6px 0; line-height: 1.7; }
.wg-idle-tip { color: #888; font-size: 13px; }
.wg-quota { color: #606266; font-size: 13px; }
.wg-quota b { color: #e6a23c; }
.wg-quota-double { color: #f56c6c; font-weight: bold; }
/* ============ 传送带场景 ============ */
.belt-scene {
  position: relative;
  display: flex;
  align-items: flex-end;
  height: 112px;
  margin-bottom: 14px;
  border: 2px solid #8d6e63;
  border-radius: 12px;
  background: linear-gradient(180deg, #f3ece2, #e8dfd2);
  overflow: hidden;
}
.belt {
  position: relative;
  flex: 1;
  height: 52px;
  margin: 0 0 8px 42px;
  border-radius: 26px;
  background: repeating-linear-gradient(
    -45deg,
    #5d4037 0 8px,
    #4e342e 8px 16px
  );
  border: 2px solid #3e2723;
  box-shadow: inset 0 4px 8px rgba(0,0,0,.35);
  animation: belt-scroll .4s linear infinite;
}
/* 45°条纹水平周期 ≈ 16/cos45°，滚动一个周期无缝循环 */
@keyframes belt-scroll {
  from { background-position: 0 0; }
  to { background-position: -22.63px 0; }
}
.belt-arrow {
  position: absolute;
  right: 10px;
  top: -4px;
  font-size: 15px;
  color: #3e2723;
  opacity: .55;
  pointer-events: none;
  animation: arrow-nudge .8s ease-in-out infinite;
}
@keyframes arrow-nudge {
  0%, 100% { transform: translateX(0); }
  50% { transform: translateX(-4px); }
}
.belt-machine {
  width: 42px;
  height: 64px;
  margin: 0 8px 8px 0;
  border-radius: 8px 0 0 8px;
  border: 2px solid #546e7a;
  background: linear-gradient(180deg, #78909c, #546e7a);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.belt-machine-icon { font-size: 24px; }
.machine-preview {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}
.machine-preview-emoji {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  background: #fff;
  border: 2px solid #cfd8dc;
  border-radius: 50%;
  opacity: .85;
  animation: preview-pulse 1.2s ease-in-out infinite;
}
.machine-preview-label { font-size: 9px; color: #eceff1; letter-spacing: 1px; }
@keyframes preview-pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.1); }
}
.machine-pop { animation: machine-shake .3s; }
@keyframes machine-shake {
  0%, 100% { transform: rotate(0); }
  30% { transform: rotate(-4deg); }
  60% { transform: rotate(3deg); }
}
.belt-guard {
  width: 42px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #f57f17;
  background: linear-gradient(180deg, #ffe082, #ffca28);
  border-radius: 8px;
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 2;
}
.belt-guard-icon { font-size: 24px; }
.belt-item {
  position: absolute;
  top: -6px;
  width: 44px;
  height: 44px;
  margin-left: -22px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border: 2px solid #b8860b;
  border-radius: 50%;
  box-shadow: 0 2px 6px rgba(0,0,0,.3);
  cursor: grab;
  user-select: none;
  touch-action: none;
  transition: left .1s linear;
  z-index: 3;
  animation: item-pop .25s ease-out;
}
@keyframes item-pop {
  0% { transform: scale(.2); }
  60% { transform: scale(1.15); }
  100% { transform: scale(1); }
}
.belt-item-held { opacity: 0; }
.belt-item-emoji { font-size: 24px; pointer-events: none; }
/* ============ 手持提示（点选模式） ============ */
.wg-carrying {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  padding: 5px 12px;
  border-radius: 16px;
  background: linear-gradient(90deg, #fff3e0, #ffe0b2);
  border: 1px dashed #ff9800;
  font-size: 13px;
  color: #e65100;
}
.wg-carrying-emoji { font-size: 20px; }
/* ============ 分类箱 ============ */
.sort-cats {
  display: flex;
  gap: 10px;
  margin-bottom: 12px;
}
.sort-cat {
  position: relative;
  flex: 1;
  border: 2px dashed #b8860b;
  border-radius: 10px;
  padding: 10px 0;
  text-align: center;
  background: #fff8e1;
  cursor: pointer;
  transition: transform .15s, background .2s, border-color .2s, box-shadow .2s;
}
.sort-cat:hover { transform: translateY(-2px); box-shadow: 0 4px 10px rgba(184,134,11,.25); }
.sort-cat-good {
  border-color: #43a047;
  border-style: solid;
  background: #e8f5e9;
}
.sort-cat-bad {
  border-color: #e53935;
  border-style: solid;
  background: #ffebee;
}
.sort-cat-pop { animation: cat-pop .3s; }
@keyframes cat-pop {
  0% { transform: scale(1); }
  40% { transform: scale(1.12); }
  100% { transform: scale(1); }
}
.cat-badge {
  position: absolute;
  top: -8px;
  right: -6px;
  min-width: 20px;
  height: 20px;
  line-height: 20px;
  border-radius: 10px;
  background: #e53935;
  color: #fff;
  font-size: 12px;
  font-weight: bold;
}
.cat-emoji { display: block; font-size: 22px; }
.cat-name { display: block; font-size: 12px; color: #555; margin-top: 2px; }
/* ============ 操作条 ============ */
.sort-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
}
.sort-actions-tip { font-size: 12px; color: #999; }
/* ============ 清扫（地鼠式） ============ */
.whack-board {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  padding: 16px 14px;
  border-radius: 12px;
  border: 2px solid #8d6e63;
  background: linear-gradient(180deg, #efe7dc, #e0d5c4);
  box-shadow: inset 0 2px 10px rgba(62,39,32,.15);
}
.whack-hole {
  position: relative;
  aspect-ratio: 1 / .82;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  cursor: pointer;
  border-radius: 10px;
  transition: background .2s;
}
.whack-hole-hot { background: rgba(255,193,7,.12); }
.whack-hole::after {
  content: '';
  position: absolute;
  bottom: 2px;
  left: 15%;
  right: 15%;
  height: 20px;
  border-radius: 50%;
  background: radial-gradient(ellipse at center, #26190f 55%, #3e2723 100%);
  box-shadow: inset 0 4px 7px rgba(0,0,0,.65), 0 1px 2px rgba(255,255,255,.35);
}
.whack-debris {
  position: relative;
  z-index: 1;
  font-size: 32px;
  margin-bottom: 12px;
  filter: drop-shadow(0 3px 4px rgba(0,0,0,.35));
  animation: debris-pop .18s ease-out;
}
@keyframes debris-pop {
  from { transform: translateY(30px) scale(.6); }
  to { transform: translateY(0) scale(1); }
}
.whack-dust {
  position: absolute;
  z-index: 2;
  left: 50%;
  top: 40%;
  transform: translate(-50%, -50%);
  font-size: 24px;
  animation: dust-pop .35s ease-out both;
}
.wg-miss { color: #e57373; }
@keyframes dust-pop {
  0% { transform: scale(.3) rotate(-20deg); opacity: 0; }
  60% { transform: scale(1.3) rotate(8deg); opacity: 1; }
  100% { transform: scale(1) rotate(0); }
}
/* ============ 结果 ============ */
.wg-result {
  margin-top: 14px;
  text-align: center;
  padding: 16px 14px;
  border-radius: 10px;
  background: linear-gradient(180deg, #f1f8e9, #eaf5e0);
  animation: result-in .3s ease-out;
}
@keyframes result-in {
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
}
.wg-result-title { margin: 0 0 8px; line-height: 1.6; }
.wg-result-title.ok { color: #4caf50; font-weight: bold; }
.wg-result-title.bad { color: #e53935; font-weight: bold; }
.wg-reward-row {
  display: flex;
  justify-content: center;
  gap: 22px;
  margin-bottom: 12px;
}
.wg-reward-item { font-size: 15px; color: #b8860b; font-weight: bold; }
.wg-result-actions { display: flex; justify-content: center; gap: 10px; }
/* ============ 得分飘字 ============ */
.wg-floaters {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  z-index: 5;
  overflow: visible;
}
.wg-floater {
  position: absolute;
  transform: translate(-50%, 0);
  font-size: 16px;
  font-weight: bold;
  white-space: nowrap;
  animation: float-up .9s ease-out both;
  pointer-events: none;
}
.wg-floater.good { color: #43a047; text-shadow: 0 1px 2px #fff; }
.wg-floater.bad { color: #e53935; text-shadow: 0 1px 2px #fff; }
@keyframes float-up {
  from { opacity: 1; transform: translate(-50%, 0); }
  to { opacity: 0; transform: translate(-50%, -46px); }
}
/* ============ 移动端适配 ============ */
@media (max-width: 768px) {
  #warehouseGameDiv /deep/ .el-dialog {
    width: 92% !important;
    margin-top: 8vh !important;
  }
  .wg-top { gap: 8px; font-size: 13px; flex-wrap: wrap; }
  .wg-timer-wrap { width: 88px; }
  .belt-scene { height: 96px; border-radius: 10px; }
  .belt { height: 46px; margin-left: 34px; }
  .belt-machine, .belt-guard { width: 34px; height: 56px; }
  .belt-machine-icon, .belt-guard-icon { font-size: 19px; }
  .machine-preview-emoji { width: 22px; height: 22px; font-size: 13px; }
  .machine-preview-label { font-size: 8px; }
  .belt-item { width: 38px; height: 38px; margin-left: -19px; top: -4px; }
  .belt-item-emoji { font-size: 20px; }
  .sort-cats { flex-wrap: wrap; gap: 8px; }
  .sort-cat { flex: 1 1 42%; }
  .whack-board { gap: 8px; padding: 12px 10px; }
  .whack-debris { font-size: 26px; }
  .whack-dust { font-size: 20px; }
}
</style>

<style>
/* 跟手克隆（body 下，用全局样式避免 scoped 属性失效） */
.wg-drag-clone {
  position: fixed;
  width: 48px;
  height: 48px;
  margin: -24px 0 0 -24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  background: #fff;
  border: 2px solid #b8860b;
  border-radius: 50%;
  box-shadow: 0 6px 14px rgba(0,0,0,.4);
  pointer-events: none;
  z-index: 3000;
}
</style>
